import React from 'react';
import { Redirect } from 'react-router-dom';
import { useQueryParams } from 'src/hooks/utils';
import useFormSubmit from './hooks/useFormSubmit';

const SSOAuthorizePage = () => {
  const {
    authorization_code: authorizationCode,
    target_url: targetUrl,
  } = useQueryParams(window.location);

  const redirectUrl = useFormSubmit(authorizationCode, targetUrl);

  if (redirectUrl) {
    return (
      <Redirect to={redirectUrl} />
    );
  }

  return null;
};

export default React.memo(SSOAuthorizePage);
